import styled from 'styled-components';
import { hexToRgba } from '../../utils/style';
import { StyleColor } from '../../utils/styles-constants';

interface CookieNotificationProps {
	shouldDisplay: boolean;
}

export const Container = styled('div') `
		position: fixed;
		bottom: 20px;
		width: 600px;
		left: calc(50% - 300px);
		background: ${hexToRgba(StyleColor.Black, 70)};
		color: ${StyleColor.Grey100};
		z-index: 500;
		padding: 35px 45px 35px 35px;
		border-radius: 5px;
		font-size: 12px;
		box-sizing: border-box;
		line-height: 1.5;

		transition: opacity 0.5s;
		${(props: CookieNotificationProps) =>
			props.shouldDisplay
			? `opacity: 1;`
			: `opacity: 0;
				pointer-events: none;`
		}

		@media(max-width: 700px) {
			width: calc(100vw - 40px);
			left: 20px;
		}

		& > * > a {
			color: ${StyleColor.Grey100};
		}
`;

export const CloseButton = styled('div') `
		position: absolute;
		right: 10px;
		top: 10px;
		cursor: pointer;

		> svg {
			width: 12px;
			height: 12px;
			fill: ${StyleColor.Grey100};
		}
`;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/styles.ts